import { render } from "./BestiaryAttackCompendiumModal.vue?vue&type=template&id=05a01f48"
import script from "./BestiaryAttackCompendiumModal.vue?vue&type=script&lang=js"
export * from "./BestiaryAttackCompendiumModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__